import { Controller } from '@hotwired/stimulus';

// Sets data-intro-animation-state="played" on first visibility.
// CSS keyframes gate on this attribute so the effect runs once per element lifetime.
export default class extends Controller {
  connect() {
    if (this.element.dataset.introAnimationState === 'played') return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.element.dataset.introAnimationState = 'played';
            this.observer?.disconnect();
            this.observer = null;
          }
        });
      },
      { threshold: 0.5 },
    );
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
    this.observer = null;
  }
}
